import React from 'react';
import { toast, ToastOptions } from 'react-toastify';
import { checkDocument } from '@buyhatke/custom-lib-js';

import bellIcon from '@img/bellIcon_solid.svg';

import { Button } from '@components';

const contextClass = {
	success: 'bg-green-600 text-white',
	error: 'bg-red-600 text-white',
	warning: 'bg-orange-700 text-white',
	default: 'bg-white text-dharkyBhicky',
};

const listenToEscape = (e: KeyboardEvent) => {
	if (e.code === 'Escape') {
		if (
			!document.body.classList.contains('modal-shown') ||
			!document.body.classList.contains('drawer-shown')
		) {
			toast.dismiss();
			document.removeEventListener('keyup', listenToEscape);
		}
	}
};

const toastAutoClose = () => {
	if (checkDocument) {
		document.addEventListener('keyup', listenToEscape);
	}
};

// if msg contains word any red flag words ,
// then returns error otherwise success
const detectNotifyType = (msg: string) => {
	const redFlagWordPattern = /fail|cannot|oops|sorry|error|cant|can't/i;
	return redFlagWordPattern.test(msg) ? 'error' : 'success';
};

export const toastNotify = (
	msg: string,
	options: ToastOptions & {
		toastClassNames?: string;
	} = {}
) => {
	toast(msg, {
		icon: () => {
			if (options.icon === false) {
				return false;
			}
			return (
				options.icon || (
					<img
						// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
						src={bellIcon.src}
						alt="toast Icon"
						className="-mb-8"
					/>
				)
			);
		},
		autoClose: 2000,
		draggablePercent: 30,
		position: toast.POSITION.BOTTOM_CENTER,
		hideProgressBar: true,
		className: `items-start text-sm items-start min-h-0 ${
			contextClass[
				(options.type as keyof typeof contextClass) ||
					detectNotifyType(msg)
			]
		} ${options.toastClassNames || ''}`,
		bodyClassName: 'flex items-start gap-1 tracking-wider',
		toastId: 'toastwa',
		closeButton: (
			<Button
				variant="minimal"
				size="tiny"
				className="bg-black-a-5 leading-x font-light p-2 pt-1 text-2xl text-white focus:outline-none"
				type="button"
				aria-label="close"
			>
				&times;
			</Button>
		),
		...options,
	});
	toastAutoClose();
};

export const ToastContext = React.createContext(toastNotify);
